<div
    class="agpr-checkbox"
    [class.agpr-checkbox--spaced]="bottomMargin"
>
    <div
        class="agpr-checkbox-srOnly"
        [ngClass]="{'agpr-checkbox-srOnly--button': style === checkboxTypesEnum.button}"
    >
        <input
            [id]="id + '_checkbox'"
            type="checkbox"
            class="agpr-checkbox-srOnlyInput"
            [value]="value"
            [name]="name ? name : (id + '_checkboxName')"
            [checked]="checked"
            [disabled]="disabled && (!checked || canBeDisabledWhenChecked)"
            [attr.tabindex]="tabindex"
            [agprTooltip]="tooltip"
            tooltipPosition="top"
            [initiallyFocusable]="initiallyFocusable"
            attr.aria-labelledby="{{id}}_checkboxLabel {{id}}_checkboxHiddenLabel {{ariaLabelledBy}}"
            [attr.aria-describedby]="ariaDescribedBy"
            (change)="handleChange($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
        >
        @if (style === checkboxTypesEnum.iconBadge && checked) {
            <span
                class="iconBadge-checkIcon fa-solid {{ checkedIcon }}"
                [class.iconBadge-checkIcon--disabled]="disabled"
            >
                <span class="iconBadge-checkIcon-background fa-solid fa-square"></span>
            </span>
        }
    </div>
    <!-- This button is only for visual users. Screen reader users will interact with input above -->
    <div
        *ngIf="style === checkboxTypesEnum.normal"
        [id]="id + '_checkboxInput'"
        class="agpr-checkbox-input agpr-checkbox-input-normal"
        [ngClass]="{
            'fa-regular fa-square': !checked && !partialSelected,
            'fa-square-check': checked,
            'fa-square-minus': partialSelected,
            'fa-solid': checked || partialSelected,
            'fa-duotone': disabled && (!checked && !partialSelected),
            'agpr-checkbox-input-normal--focused': focused,
            'agpr-checkbox-input-normal--disabled': disabled && (!checked || canBeDisabledWhenChecked)
        }"
        aria-hidden="true"
        (click)="onClick($event)"
    >
    </div>
    <button
        *ngIf="style === checkboxTypesEnum.button"
        [id]="id + '_checkboxInput'"
        class="agpr-checkbox-button"
        [ngClass]="{
            'agpr-checkbox-button--checked': checked,
            'agpr-checkbox-button--disabled': disabled,
            'agpr-checkbox-button--focused': focused
        }"
        [pTooltip]="style === checkboxTypesEnum.button ? (tooltip | localize) : null"
        tooltipPosition="top"
        tabindex="-1"
        aria-hidden="true"
        (click)="onClick($event)"
    >
        <span
            *ngIf="icon"
            role="img"
            [class]="icon"
            [ngClass]="{
                'fa-solid': checked,
                'fa-regular': !checked
            }"
            [attr.aria-label]="tooltip | localize"
        ></span>
        {{ label | localize }}
        <ng-content></ng-content>
    </button>
    <label
        *ngIf="style === checkboxTypesEnum.normal"
        [for]="id + '_checkbox'"
        [id]="id + '_checkboxLabel'"
        class="agpr-checkboxLabel"
        [ngClass]="{ 'agpr-checkboxLabel--disabled': disabled }"
        (agprClickUnless)="onClick($event)"
        [agprClickUnlessSelectors]="['a']"
    >
        <span class="agpr-checkboxLabel-label" [class]="labelStyleClass">{{ label | localize }}</span>
        <ng-content></ng-content>
    </label>
    <span
        [id]="id + '_checkboxHiddenLabel'"
        class="u-srOnly"
        aria-hidden="true"
    >
        {{ (hiddenLabel || tooltip) | localize }}
    </span>
    <span
        *ngIf="infoCircleTooltip"
        role="img"
        [id]="id + '_checkboxInfo'"
        class="fa-regular fa-circle-info agpr-checkboxInfo"
        [agprTooltip]="infoCircleTooltip"
        [useTooltipAsAriaLabel]="false"
        [tooltipPosition]="tooltipPosition"
        [attr.aria-label]="
            (disabled ? (label | localize) + ' checkbox not available. ' : '') + (infoCircleTooltip | localize)
        "
    ></span>
    @if(style === checkboxTypesEnum.normal && icon) {
        <span
            role="img"
            class="agpr-checkboxIcon"
            [class]="icon"
            [ngClass]="{'agpr-checkboxIcon--disabled': disabled}"
            [agprTooltip]="iconTooltip"
            tooltipPosition="top"
            [attr.aria-label]="iconTooltip | localize"
        ></span>
    }
    @if (style === checkboxTypesEnum.iconBadge) {
        <button
            [id]="id + '_iconBadge'"
            class="iconBadge"
            [ngClass]="{
                'iconBadge--checked': checked,
                'iconBadge--disabled': disabled
            }"
            [pTooltip]="(iconBadgeTooltip || tooltip) | localize"
            tooltipPosition='top'
            tabindex="-1"
            aria-hidden="true"
            (click)="onClick($event)"
        >
            @if (imgLabel) {
                <img
                    class="iconBadge--img"
                    [src]="imgLabel"
                    [alt]="(iconBadgeTooltip || tooltip) | localize"
                />
            }
            @if (iconLabel) {
                <span
                    role="img"
                    [class]="`iconBadge--icon ${iconLabel}`"
                    [attr.aria-label]="(iconBadgeTooltip || tooltip) | localize"
                ></span>

            }
        </button>
    }
</div>
